export default "__VITE_ASSET__DCh80KxS__"